import { render } from "./StatisticTraders.vue?vue&type=template&id=705ea49a&ts=true"
import script from "./StatisticTraders.vue?vue&type=script&lang=ts"
export * from "./StatisticTraders.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__